import { call, put, takeEvery } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { eChuongTrinhDaoTaoActionIds } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { chuongTrinhDaoTaoApi } from "../../../api/chuong-trinh-dao-tao/chuongTrinhDaoTaoApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* chuongTrinhDaoTaoSaga(): any {
    yield takeEvery(eChuongTrinhDaoTaoActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(chuongTrinhDaoTaoApi.SelectByUser);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chuongTrinhDaoTao.LOAD_ERROR(res.message ?? "Có lỗi")
        );
    }
}
